<template>
    <main class="main simple">
        <router-view />
        <Notifications />
    </main>
</template>
<script>
import Notifications from "@/components/Modals/Notifications/index";
export default {
    components: {
        Notifications
    },
}
</script>